import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { KeyValue } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyService } from '@services/company.service';
import { Toaster } from '@services/toaster.service';
import { TAGS_TO_MONTHLY_PERIODS, TAGS_TO_QUARTERLY_PERIODS } from '@models/periods.model';

@Component({
  selector: 'ngx-voucher-creation',
  templateUrl: './voucher-creation-modal.component.html',
  styleUrls: ['./voucher-creation-modal.component.scss'],
})
export class VoucherCreationModalComponent implements OnInit, OnDestroy {
  voucherForm: FormGroup;

  @Input() organizationId;
  @Input() purchaseOrderId;
  @Input() supplierName;
  loading = false;

  tagsToMonthlyPeriods = TAGS_TO_MONTHLY_PERIODS;
  tagsToQuarterlyPeriods = TAGS_TO_QUARTERLY_PERIODS;

  originalOrder = (a: KeyValue<number,string>, b: KeyValue<number,string>): number => {
    return 0;
  }

  constructor(
    private ngbActiveModal: NgbActiveModal,
    private fb: FormBuilder,
    private $company: CompanyService,
    private $toaster: Toaster,
  ) {
  }

  ngOnInit() {
    this.voucherForm = this.fb.group({
      taxid: [null, [Validators.required]],
      period: [null, [Validators.required]],
      cv1: [this.supplierName, [Validators.required]],
      cv2: [null, []],
      cvaddr1: [null, []],
      cvaddr2: [null, []],
      description1: [null, [Validators.required]],
      description2: [null, []],
      description3: [null, []],
      description4: [null, []],
      description5: [null, []],
      description6: [null, []],
      description7: [null, []],
      qty1: [null, [Validators.required]],
      qty2: [null, []],
      qty3: [null, []],
      qty4: [null, []],
      qty5: [null, []],
      qty6: [null, []],
      qty7: [null, []],
      unit1: [null, [Validators.required]],
      unit2: [null, []],
      unit3: [null, []],
      unit4: [null, []],
      unit5: [null, []],
      unit6: [null, []],
      unit7: [null, []],
      price1: [null, [Validators.required]],
      price2: [null, []],
      price3: [null, []],
      price4: [null, []],
      price5: [null, []],
      price6: [null, []],
      price7: [null, []],
      sub1: [{value: '', disabled: true}, []],
      sub2: [{value: '', disabled: true}, []],
      sub3: [{value: '', disabled: true}, []],
      sub4: [{value: '', disabled: true}, []],
      sub5: [{value: '', disabled: true}, []],
      sub6: [{value: '', disabled: true}, []],
      sub7: [{value: '', disabled: true}, []],
      total: [{value: '', disabled: true}, []],
    });

    this.voucherForm.valueChanges.subscribe(v => {
      console.log(v);
      v.sub1 = v.qty1 * v.price1;
      v.sub2 = v.qty2 * v.price2;
      v.sub3 = v.qty3 * v.price3;
      v.sub4 = v.qty4 * v.price4;
      v.sub5 = v.qty5 * v.price5;
      v.sub6 = v.qty6 * v.price6;
      v.sub7 = v.qty7 * v.price7;
      v.total = v.sub1 + v.sub2 + v.sub3 + v.sub4 + v.sub5 + v.sub6 + v.sub7;
      this.voucherForm.patchValue(v, {emitEvent: false, onlySelf: true});
    });
  }

  save() {
    if (!this.voucherForm.valid) {
      this.$toaster.show('error', 'An error occurred', 'Please fill all required fields and try again');
      return;
    }
    let voucherPayload = {fields: this.voucherForm.getRawValue()} as any;
    // v.sub1_2 = v.sub1;
    // v.sub2_2 = v.sub2;
    // v.sub3_2 = v.sub3;
    // v.sub4_2 = v.sub4;
    // v.sub5_2 = v.sub5;
    // v.sub6_2 = v.sub6;
    // v.sub7_2 = v.sub7;
    // v.total2 = v.total;
    this.loading = true;
    this.$company.rcdssUploadElectronicVoucher(this.organizationId, this.purchaseOrderId, voucherPayload.period, {fields: voucherPayload})
      .subscribe(
        res => {
          this.openAndRetryPandaDocDocumentById(res.external_id);
        },
        error => {
          this.loading = false;
          console.error(error);
          this.$toaster.show('error', 'An error occurred', 'Please try again later');
        },
      );
  }

  openAndRetryPandaDocDocumentById(documentId, tries = 0) {
    this.$company.rcdssGetLinkToContractDocument(this.organizationId, this.purchaseOrderId, documentId)
      .subscribe(
        res => {
          this.loading = false;
          this.ngbActiveModal.close(res);
        },
        error => {
          console.error(error);
          if (tries > 20) {
            this.loading = false;
            this.$toaster.show('error', 'An error occurred', 'Please try again later');
            return;
          }
          setTimeout(this.openAndRetryPandaDocDocumentById.bind(this), 3000, documentId, tries+1);
        },
      );
  }

  closeModal() {
    this.ngbActiveModal.dismiss();
  }

  ngOnDestroy(): void {
  }

}